export default __webpack_public_path__ + "static/media/TheaLovelace.fbefef24.png";